import React from "react";
import { useSelector } from "react-redux";
import { getRightContent, setAdditionalClasses } from "../assets/js/utils";

export default function CheckBoxList({
  list,
  chapter,
  handleOnChange,
  checkBoxList,
}) {
  const generalSettings = useSelector((state) => state.ui.generalSettings);
  return (
    <ul className="ckeckbox-list list">
      {list.map((listItem, index) => (
        <li
          key={index}
          className={`checkbox-list__item${setAdditionalClasses(
            ["display-none"],
            [listItem.hide]
          )}`}
        >
          <input
            id={`custom-checkbox-${chapter}-${index}`}
            type="checkbox"
            value={listItem.value}
            checked={checkBoxList && checkBoxList[index]}
            onChange={() => handleOnChange(chapter, index)}
            className="checkbox-input"
          />
          <label
            className="checkbox-list__item-label"
            htmlFor={`custom-checkbox-${chapter}-${index}`}
          >
            {getRightContent(generalSettings.rtlLanguage, listItem.label)}
          </label>
        </li>
      ))}
    </ul>
  );
}
